module.exports = __webpack_public_path__ + "media/components/app-store/static/google-play__qr-download-en-6bf9e1f8b50c7d76b3b677876c35a5d2.svg";